import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6da77467"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "footer" }
const _hoisted_2 = { class: "main flex-bet" }
const _hoisted_3 = { class: "header-title" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"content flex-bet\" data-v-6da77467><ul data-v-6da77467><li data-v-6da77467><a href=\"https://www.piesat.cn\" target=\"_blank\" data-v-6da77467>航天宏图</a></li><li data-v-6da77467><a href=\"https://engine.piesat.cn/appstore?todetail=jr0o88xEWDja438KydsG\" target=\"_blank\" data-v-6da77467>火情监测预警</a></li></ul><ul data-v-6da77467><li data-v-6da77467><a href=\"https://nync.piesat.cn/demo\" target=\"_blank\" data-v-6da77467>航天宏图固废地图</a></li><li data-v-6da77467><a href=\"https://book.yunzhan365.com/onwnb/ejye/mobile/index.html\" target=\"_blank\" data-v-6da77467>WeWater水环境智慧监管</a></li></ul><ul data-v-6da77467><li data-v-6da77467><a href=\"https://engine.piesat.cn/UAV\" target=\"_blank\" data-v-6da77467>PIE Engine UAV</a></li><li data-v-6da77467><a href=\"https://engine.piesat.cn\" target=\"_blank\" data-v-6da77467>PIE-Engine</a></li></ul></div>", 1)
const _hoisted_6 = { class: "scan-code flex-bet" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "小程序", -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "咨询群", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copyright" }, [
  /*#__PURE__*/_createTextVNode(" Copyright © 2022 航天宏图信息技术股份有限公司 版权所有 | "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://beian.miit.gov.cn",
    target: "_blank"
  }, "京ICP备08011069号"),
  /*#__PURE__*/_createTextVNode(" | "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035123",
    target: "_blank"
  }, "京公网安备 11010802035123号")
], -1))

import { useRoute, useRouter, } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { sysConfig, } = window as any;

const router = useRouter();
const route = useRoute();
const handlerClick = () => {
  router.push('/');

  // 如果已经在首页，刷新页面
  if (route.path === '/') {
    router.go(0);
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "logo",
        onClick: handlerClick
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _unref(sysConfig).indexLogo,
            alt: ""
          }, null, 8, _hoisted_4),
          _createTextVNode(_toDisplayString(_unref(sysConfig).indexTitle), 1)
        ]),
        _createElementVNode("p", null, _toDisplayString(_unref(sysConfig).indexSubtitle), 1)
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: _unref(sysConfig).miniCode,
            alt: ""
          }, null, 8, _hoisted_7),
          _hoisted_8
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: _unref(sysConfig).groupCode,
            alt: ""
          }, null, 8, _hoisted_9),
          _hoisted_10
        ])
      ])
    ]),
    _hoisted_11
  ]))
}
}

})